module.exports = __webpack_public_path__ + "static/img/home_advantage_bg_2.ef5fd45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h5/official/home_advantage_bg_2.png
// module id = RMOl
// module chunks = 1